<template>
  <GroupTable
    :longTableId="longTableId"
    :cols="cols"
    :formData="formData"
  />
</template>

<script>
import long_table_mixin from "@/components/statistics/stats/tabs/long_table_mixin";
import GroupTable from "@/components/statistics/general/GroupTable.vue";
import { getPercent } from "@/utils/general";

export default {
  mixins: [long_table_mixin],

  components: {
    GroupTable
  },

  data() {
    return {
      longTableId: "opens-table",
      cols: {
        date: {
          label: "Период"
        },
        delivered: {
          label: "Доставлено",
          className: "bold"
        },
        unsubscribed:  {
          label: "Отписались"
        }
      }
    }
  },

  methods: {
    formData(arr, groupBy) {
      return arr.map(i => {
        const { date, delivered, unsubscribed, sent } = i;

        return {
          date: groupBy.id === 1 ? mt.tsToLocalDateTime(date) : mt.tsToLocalDateTime(date).substring(0, 10),
          delivered: `<b>${this.fNum.format(delivered)}</b> (${getPercent(sent, delivered)}%)`,
          unsubscribed: `<b>${unsubscribed}</b> (${getPercent(delivered, unsubscribed)}%)`
        };
      });
    }
  }
}
</script>
